import CSS from 'csstype'

export const manufacturerPanel: CSS.Properties = {
    display: "table-cell",
    verticalAlign: "middle",
    textAlign: "center"
}